import React, { ReactNode, useEffect } from 'react';

import { DesiredPositionStore } from './desired-position/desired-position.store';
import { WorkExperienceStore } from './work-experience/work-experience.store';
import { EducationInfoStore } from './education-info/education-info.store';
import { AdditionalInfoStore } from './additonal-info/additonal-info.store';
import { CreateResumeStep, CreateResumeStore } from './create-resume.store';

const CreateResumeContext = React.createContext<CreateResumeStore | null>(null);

export const CreateResumeProvider = ({
  children,
  initialStep,
}: {
  children: ReactNode;
  initialStep?: CreateResumeStep;
}) => {
  const [store] = React.useState<CreateResumeStore>(
    () =>
      new CreateResumeStore(
        new DesiredPositionStore(),
        new WorkExperienceStore(),
        new EducationInfoStore(),
        new AdditionalInfoStore(),
        initialStep
      )
  );

  useEffect(() => {
    let mounted = true;

    store.loadInitialValues(() => mounted);

    return () => {
      mounted = false;
      store.dispose();
    };
  }, [store]);

  return (
    <CreateResumeContext.Provider value={store}>{children}</CreateResumeContext.Provider>
  );
};

export const useCreateResumeContext = () => {
  const ctx = React.useContext(CreateResumeContext);
  if (!ctx) {
    throw new Error('useCreateResumeContext must be used inside CreateResumeProvider');
  }
  return ctx;
};
